import { SxProps, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

export interface InputProps
  extends Omit<
    TextFieldProps,
    'size' | 'variant' | 'margin' | 'fullWidth' | 'error'
  > {
  error?: string;
  info?: string;
}

const Input = ({ error, info, ...rest }: InputProps) => (
  <TextField
    slotProps={{ inputLabel: { shrink: true } }}
    size="small"
    variant="outlined"
    margin="none"
    fullWidth
    error={!!error}
    helperText={error ?? info}
    sx={sx}
    {...rest}
  />
);

const sx: SxProps = {
  '& .MuiFormHelperText-root': { marginLeft: 0, marginTop: '0.125rem' },
};

export default Input;
